const MapProjection = {
    SphericalMercator: 3857
};

Object.freeze(MapProjection);

export default MapProjection;